var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-show-body-form-item flex flex-col"})
}
var staticRenderFns = []

export { render, staticRenderFns }